const Citas = () => <div><h3>📅 Gestión de Citas</h3></div>;
export default Citas;